<template>
  <div style="background:#f0f2f5;height:100vh;">
    <div class="wscn-http404">
      <div class="pic-404">
        <img class="pic-404__parent animated tada" :src="img_404" alt="404">
      </div>
      <div class="bullshit">
        <div class="bullshit__oops">OOPS!</div>
        <div class="bullshit__headline">{{ message }}</div>
        <div class="bullshit__info">请检查您输入的网址是否正确，请点击以下按钮返回主页或者返回上一页</div>
        <el-row :gutter="20">
            <el-col :span="12">
                <router-link to="/projectlist">
                    <el-button type="primary" round size="large">返回首页</el-button>
                </router-link>
            </el-col>
            <el-col :span="12">
                <el-button type="primary" round size="large"  @click="goBack">返回上一页</el-button>
            </el-col>
        </el-row>
      </div>
    </div>
  </div>
</template>

<script>
import img_404 from '@/assets/images/img_error/404.png'

export default {
  name: 'errorpage404',
  data() {
    return {
      img_404,
    }
  },
  computed: {
    message() {
      return '找不到您说的这个页面......'
    }
  },
  methods: {
      goBack(){
          this.$router.go(-1);
      }
  }
}
</script>

<style lang="less" scoped>
.wscn-http404 {
  position: relative;
  width: 1200px;
  padding: 0 200px;
  overflow: hidden;
  .pic-404 {
    position: relative;
    float: left;
    width: 600px;
    padding: 150px 0;
    overflow: hidden;
    &__parent {
      width: 100%;
    }
  }
  .bullshit {
    position: relative;
    float: left;
    width: 400px;
    padding: 200px 0 100px;
    overflow: hidden;
    &__oops {
      font-size: 32px;
      font-weight: bold;
      line-height: 40px;
      color: #1482f0;
      opacity: 0;
      margin-bottom: 20px;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-fill-mode: forwards;
    }
    &__headline {
      font-size: 20px;
      line-height: 24px;
      color: #1482f0;
      opacity: 0;
      margin-bottom: 10px;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-delay: 0.1s;
      animation-fill-mode: forwards;
    }
    &__info {
      font-size: 13px;
      line-height: 21px;
      color: grey;
      opacity: 0;
      margin-bottom: 30px;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-delay: 0.2s;
      animation-fill-mode: forwards;
    }
    &__return-home {
      display: block;
      float: left;
      width: 110px;
      height: 36px;
      background: #1482f0;
      border-radius: 100px;
      text-align: center;
      color: #ffffff;
      opacity: 0;
      font-size: 14px;
      line-height: 36px;
      cursor: pointer;
      animation-name: slideUp;
      animation-duration: 0.5s;
      animation-delay: 0.3s;
      animation-fill-mode: forwards;
    }
    @keyframes slideUp {
      0% {
        transform: translateY(60px);
        opacity: 0;
      }
      100% {
        transform: translateY(0);
        opacity: 1;
      }
    }
  }
}
</style>
